import { buildThemeAliases } from "src/legacy/utils"
import { base } from "./base"

export const inputFocusAliases = buildThemeAliases(base, {
  inline: "none",
  primary: "2Transparent",
})

export type InputFocusAliases = Record<keyof typeof inputFocusAliases, string>
